import * as React from 'react';
import b_ from 'b_';

import './index.scss';
import * as socialIcon from './static/img/social-icons.svg';

interface Props {
  to: string;
  size: 'big' | 'small';
  type: 'utmag' | 'youtube' | 'fb' | 'vk' | 'twitter' | 'gplus' | 'ok' | 'telegram' | 'medium';
  text: string;
}

const b = b_.with('social-button');

class Link extends React.Component<Props> {
  render() {
    const { size, type, text, to } = this.props;

    return (
      <a className={b({ size, type })} href={to} target="_blank" rel="noopener">
        <svg className={b('icon')}>
          <use xlinkHref={`${socialIcon}#social-${type}`} />
        </svg>
        <span className={b('text')}>{text}</span>
      </a>
    );
  }
}

export default Link;
